import * as React from 'react';
import { Fragment } from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Translate from './Translate';

const RiskLevels = styled<any, any>('ol')`
    ${propStyles};
    list-style: none;
`;

RiskLevels.defaultProps = {
    flex: '1 0 100%',
    alignSelf: 'stretch',
    margin: '0 0 0.5em 0',
    display: 'flex',
    fontSize: 'xs',
};

const RiskLevel = styled<any, any>('li')`
    ${propStyles};
`;

RiskLevel.defaultProps = {
    flex: '1 0 auto',
    textAlign: 'center',
    color: 'gray500',
    bgColor: 'white',
    borderWidth: '1px',
    borderColor: 'gray500',
    borderStyle: 'solid',
    margin: '0 0 0 -1px',
    paddingY: '0.25em',
    selected: {
        position: 'relative',
        color: 'white',
        bgColor: 'primary',
        borderColor: 'primary',
    },
};

const RiskLabels = styled<any, any>('div')`
    ${propStyles};
`;

RiskLabels.defaultProps = {
    display: 'flex',
    flex: '1 1 auto',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
};

const RiskLabel = styled<any, any>('p')`
    ${propStyles};
`;

RiskLabel.defaultProps = {
    color: 'gray500',
    fontSize: '11px',
};

interface SRRI {
    theme?: any;
    higherRiskLabel?: string;
    lowerRiskLabel?: string;
    rating: number;
}

export const SRRI: React.SFC<SRRI> = ({
    theme,
    higherRiskLabel = 'Higher Risk',
    lowerRiskLabel = 'Lower Risk',
    rating = 0,
}) => {
    const ratingArr = Array.from(Array(7).keys());

    return (
        <Fragment>
            <RiskLevels {...theme.SRRIRiskLevels}>
                {ratingArr.map((r, i) => (
                    <RiskLevel
                        key={i}
                        data-selected={i === rating - 1}
                        {...theme.SRRIRiskLevel}
                    >
                        {i + 1}
                    </RiskLevel>
                ))}
            </RiskLevels>
            <RiskLabels {...theme.SRRIRiskLabels}>
                <RiskLabel
                    textAlign="left"
                    margin="0 1em 0 0"
                    {...theme.SRRIRiskLabel}
                    {...theme.SRRILowerRiskLabel}
                >
                    <Translate>{lowerRiskLabel}</Translate>
                </RiskLabel>
                <RiskLabel
                    textAlign="right"
                    margin="0 0 0 1em"
                    {...theme.SRRIRiskLabel}
                    {...theme.SRRIHigherRiskLabel}
                >
                    <Translate>{higherRiskLabel}</Translate>
                </RiskLabel>
            </RiskLabels>
        </Fragment>
    );
};

export default observer(withTheme(SRRI));



// WEBPACK FOOTER //
// ./src/Components/SRRI.tsx